import { getCharacterStats } from '../../scripts/Editor/utils/characterUtils';
import { getTitle, timeColors } from '../../scripts/Editor/utils/sceneutils';

// Normalize cue notation only in a detached read-only copy, not in the screenplay.
export const characterKey = name => String(name || '').replace(/\(.*?\)/g, '').replace(/\s+/g, ' ').trim().toUpperCase();
export const characterStats = (content, name) => {
  const doc = new DOMParser().parseFromString(content || '', 'text/html');
  doc.querySelectorAll('.character').forEach(node => {
    const cue = node.textContent || '';
    const voice = /\(\s*V\s*\.?\s*O\s*\.?\s*\)/i.test(cue);
    node.textContent = `${characterKey(cue)}${voice ? ' (V.O.)' : ''}`;
  });
  return getCharacterStats({ getContent: () => doc.body.innerHTML }, characterKey(name));
};

// Match Screenwriting's existing display rule; explicit saved colours always win.
// The fallback is display-only: never write a default colour into the saved heading.
export const sceneDisplayColor = (node, heading) => node.getAttribute('data-color')?.trim()
  || timeColors[getTitle(heading).time] || '';

// CSS supports hex, rgb(a), hsl(a) and named saved colours, not just hex.
export const stripTint = color => {
  const style = document.createElement('span').style;
  style.color = color || '';
  return style.color ? `color-mix(in srgb, ${style.color} 16%, white)` : 'rgba(0,0,0,0.03)';
};